import { render, staticRenderFns } from "./TakipTalebiDegistirme.vue?vue&type=template&id=8c2801b4&scoped=true"
import script from "./TakipTalebiDegistirme.vue?vue&type=script&lang=ts"
export * from "./TakipTalebiDegistirme.vue?vue&type=script&lang=ts"
import style0 from "./TakipTalebiDegistirme.vue?vue&type=style&index=0&id=8c2801b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2801b4",
  null
  
)

export default component.exports